import React, { useMemo } from 'react';
import ApplyModal from './ApplyModal';
import ExpiredModal from './ExpiredModal';
import UnApproveModal from './UnApproveModal';
import SuccessModal from './SuccessModal';
function AppTrailApplyModal(props) {
    var url = 'https://jzb.beijing.gov.cn/oss/focus-desktop/ksCloud/webapp/client_prod/app-apply.html';
    switch (props.env) {
        case 'dev':
            url = 'http://desktop.jdcloud.com:3000/app-apply.html';
            break;
        case 'test':
            url =
                'https://jzb-test.jdcloud.com/oss/focus-desktop/webapp/jzb_web_wy_test/app-apply.html';
            break;
        case 'pre':
            url =
                'https://jzb-pre.jdcloud.com/oss/eepaas-public-pre1/webapp/jzb_web_pre/app-apply.html';
            break;
        case 'production':
        case 'prod':
            url =
                'https://jzb.beijing.gov.cn/oss/focus-desktop/ksCloud/webapp/client_prod/app-apply.html';
            break;
        case 'egov':
            url =
                'https://jzb.beijing.egov.cn/oss/focus-desktop/gov/client_prod_egov/app-apply.html';
            break;
    }
    url = props.applyPageUrl || url;
    var applyModal = useMemo(function () {
        return (React.createElement(ApplyModal, { isVisible: props.isVisible, isInsideApp: props.isInsideApp, trialDays: props.trialDays, onOk: function () {
                props.onOpenUrl
                    ? props.onOpenUrl()
                    : window.open(url + "?applicationId=" + props.applicationId + "&trialDays=" + props.trialDays);
            } }));
    }, [props, url]);
    var expiredModal = useMemo(function () {
        return React.createElement(ExpiredModal, { isVisible: props.isVisible });
    }, [props.isVisible]);
    var unApproveModal = useMemo(function () {
        return React.createElement(UnApproveModal, { isVisible: props.isVisible });
    }, [props.isVisible]);
    var successModal = useMemo(function () {
        return React.createElement(SuccessModal, { isVisible: props.isVisible });
    }, [props.isVisible]);
    return props.isUnApprove
        ? unApproveModal
        : props.isExpired
            ? expiredModal
            : props.isSuccess
                ? successModal
                : applyModal;
}
export default AppTrailApplyModal;
//# sourceMappingURL=index.js.map